import React from 'react'

export function Loading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300">
      <span className="inline-block h-2 w-2 rounded-full bg-brand-600 animate-ping" aria-hidden="true"></span>
      <span role="status" aria-live="polite">{label}</span>
    </div>
  )
}
